import React, { useMemo } from 'react';
import { FieldWrapper } from '../FieldWrapper/FieldWrapper';
import { SelectItem } from './Components/SelectItem/SelectItem';
import { useViewModel } from './hook/use-view-model';
import { SelectProps } from './type/props';
import * as styles from './Select.module.sass';
import classNames from 'classnames';

export const Select = (props: SelectProps) => {
  const { activeChoice, isOpen, itemClickHandler, meta, previewClickHandler, value, wrapperRef, openToTop } =
    useViewModel({
      name: props.name,
      choices: props.choices,
    });

  const choices = useMemo(
    () =>
      props.choices.map(choice => (
        <SelectItem
          item={choice}
          onClick={itemClickHandler}
          name={props.name}
          isActive={choice.value === value}
          key={`${props.name}-${choice.value}`}
        />
      )),
    [props.choices],
  );

  return (
    <FieldWrapper errors={meta.touched ? meta.error : undefined} label={props.label}>
      <div className={styles.wrapper} ref={wrapperRef}>
        <div onClick={previewClickHandler} className={classNames(styles.preview, { [styles.open]: isOpen })}>
          {activeChoice?.title}
          <span className={styles.arrow} />
        </div>
        {isOpen && <div className={classNames(styles.list, { [styles.openToTop]: openToTop })}>{choices}</div>}
      </div>
    </FieldWrapper>
  );
};
